module.exports = __webpack_public_path__ + "static/NightInTheWoods2-62421b2fde5b72dac9760a3e024742f9.png";